/* eslint-disable react-hooks/exhaustive-deps */
import React, { ErrorInfo, useEffect } from 'react';
import styled from 'styled-components';
import useEventHelper from '|/helpers/use-event-helper';
import useReloadPurchaseProcess from '|/helpers/use-reload-purchase-process';
import Button from '../button';
import theme from '../theme';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 4rem 0 2rem;
  min-height: 350px;

  @media (min-width: ${theme.breakpoints.md}) {
    padding-top: 3rem;
  }
`;

const ErrorDetails = styled.details`
  white-space: pre-wrap;
`;

const Content = styled.div`
  text-align: center;
  max-width: 32rem;
  padding-right: 2rem;
  padding-left: 2rem;
  color: #6d7184;
  font-weight: 390;
`;

const Text = styled.div`
  padding: 1rem 0 5rem;
  font-size: 1rem;
`;

const ChatContainer = styled.span`
  color: #228be6;
  cursor: pointer;
  text-decoration: underline;
`;

const Title = styled.h1`
  color: var(--colors-primary-blue-4);
  font-size: 1.9rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  margin-top: 0;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 4rem;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
  ${theme.font.label.m}
  width: 332px;

  @media (max-width: ${theme.breakpoints.sm}) {
    width: 100%;
  }
`;

const defaultProps = {
  error: null as null | Error,
  errorInfo: null as null | ErrorInfo
};

const Error = (props = defaultProps) => {
  const reloadPurchaseProcess = useReloadPurchaseProcess();
  const { sendEvent } = useEventHelper();

  useEffect(() => {
    sendEvent('pp_load_error');
  }, []);

  const { error, errorInfo } = props;
  return (
    <Wrapper>
      <Title>We've hit a speed bump</Title>

      {process.env.NODE_ENV !== 'production' && error && (
        <ErrorDetails open>
          {error && error.toString()}
          <br />
          {error && error.stack}
          <br />
          {errorInfo && errorInfo.componentStack}
        </ErrorDetails>
      )}

      <Content>
        <Text>
          We're sorry, something went wrong. You can{' '}
          <ChatContainer
            onClick={() => window.CarvanaAiChat.show()}
            data-analytics-id="pp_oopsie_daisy_chat"
          >
            chat
          </ChatContainer>{' '}
          with us or call 1-888-415-0755 for more help.
        </Text>

        <ButtonWrapper>
          <StyledButton
            hierarchyType="primary"
            color="blue"
            size="large"
            icon="none"
            onClick={reloadPurchaseProcess}
            text="Try Again"
            data-analytics-id="pp_oopsie_daisy_retry"
          />
        </ButtonWrapper>
      </Content>
    </Wrapper>
  );
};

export default Error;
